module.exports = __webpack_public_path__ + "img/down arrow.d8fdedc8.svg";